import { render, staticRenderFns } from "./DxActiveIngredientsVademecum.vue?vue&type=template&id=9efe86ee&"
import script from "./DxActiveIngredientsVademecum.vue?vue&type=script&lang=js&"
export * from "./DxActiveIngredientsVademecum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports